import React from 'react'
import PropTypes from 'prop-types'
import {Flex, useStyleConfig} from '@chakra-ui/react'
import BenefitIconsSwiper from './benefit-icons-swiper'
import Benefit from './benefit'

const BenefitBar = ({benefitGroup = []}) => {
    const styles = useStyleConfig('PreFooter')

    return (
        <>
            <Flex {...styles.container} data-testid="benefit-bar-container">
                <Flex {...styles.benefitBarContainer}>
                    {benefitGroup.map(({title, description, icon}, index) => (
                        <React.Fragment key={index}>
                            <Benefit
                                title={title}
                                description={description}
                                url={icon?.url}
                                alt={title}
                            />
                        </React.Fragment>
                    ))}
                </Flex>
                <Flex {...styles.benefitBarSwiper} data-testid="benefit-bar-swiper">
                    <BenefitIconsSwiper benefitGroup={benefitGroup} />
                </Flex>
            </Flex>
        </>
    )
}

BenefitBar.getTemplateName = () => 'benefit-bar'

BenefitBar.propTypes = {
    benefitGroup: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.shape({url: PropTypes.string}),
            title: PropTypes.string,
            description: PropTypes.string,
        }),
    ),
}

export default BenefitBar
